module.exports = __webpack_public_path__ + "static/media/kenobao.2c03af82.png";